import 'react-app-polyfill/stable';
import 'intl';
import 'intl/locale-data/jsonp/en.js';
import 'intl/locale-data/jsonp/zh.js';
import intl from 'react-intl-universal';
import '@formatjs/intl-locale/polyfill';
import '@formatjs/intl-pluralrules/polyfill';
import '@formatjs/intl-pluralrules/locale-data/en';
import 'url-search-params-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as serviceWorker from './serviceWorker';
import store from './store/index';
import { Provider } from 'react-redux';
import './assets/scss/common/base.scss';
import './assets/scss/common/toast.scss';
import common from './common/common';
import './utils/rem';
import './index.scss';

// common locale data
// require('intl/locale-data/jsonp/en.js');
// require('intl/locale-data/jsonp/zh.js');

// app locale data
const locales = {
  "en-US": require('./locales/en-US.json'),
  "zh-CN": require('./locales/zh-CN.json'),
};

const themeMap = [
  { key: "blingabc", value: "bli" },
  { key: "meikelight", value: "light" },
  { key: "meike", value: "mke" },
  { key: "roomboxlight", value: "light" },
  { key: "roombox", value: "gen" },
];
const setTheme = (theme = "") => {
  let target = themeMap.find(_theme => theme.toLowerCase().includes(_theme.key));
  let themeName = target ? target.value : theme;
  const root = document.getElementsByTagName("HTML")[0];
  root.classList.add(`theme-${themeName}`);
  store.dispatch({ type: 'SET_THEME', payload: { theme: themeName } });
};
const searchParams = common.getSearchParam();
console.log(searchParams);
const language = searchParams?.language || navigator.language || 'zh-cn';
setTheme(searchParams?.theme || 'roombox');

console.log(`%c[NEW]`, 'color:blue;font-size: 14px;font-weight: bolder;');

// store.subscribe(() => console.log("Store is changed: " + store.getState()));
intl.init({
  currentLocale: language.includes('en') ? 'en-US' : 'zh-CN',
  locales,
})
  .then(() => {
    // After loading CLDR locale data, start to render
    ReactDOM.render(
      <Provider store={store} >
        <App></App>
      </Provider>
      , document.getElementById('root')
    );
  });

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
